<ng-content select="app-ribbon-tab-item"></ng-content>
